import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

/**
 * 🆕 Feb 2026 — Selettore riutilizzabile "Titolo Documento" per firme OTP.
 * Legge i tipi personalizzati dell'agenzia via GET /api/agency-settings/signature-doc-types.
 * Se la chiamata fallisce, usa il preset di fallback locale.
 */
export const DOCUMENT_TITLE_PRESETS = [
  "Modulo Precontrattuale",
  "Informativa Privacy",
  "Mandato di Brokeraggio",
  "Dichiarazione Bersani",
  "Modulo 7B",
];

export default function DocumentTitleSelect({ value, onChange, testid = "document-title", label = "Titolo Documento *" }) {
  const [presets, setPresets] = useState(DOCUMENT_TITLE_PRESETS);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await api.get("/agency-settings/signature-doc-types");
        if (!alive) return;
        const arr = Array.isArray(data?.types) ? data.types.filter((t) => t && t.trim()) : [];
        if (arr.length > 0) setPresets(arr);
      } catch { /* fallback ai preset locali */ }
    })();
    return () => { alive = false; };
  }, []);

  const isPreset = presets.includes(value);
  const [custom, setCustom] = useState(!value || isPreset ? false : true);

  return (
    <div className="space-y-2">
      <Label>{label}</Label>
      <Select
        value={custom ? "__custom__" : (isPreset ? value : "")}
        onValueChange={(v) => {
          if (v === "__custom__") {
            setCustom(true);
            onChange("");
          } else {
            setCustom(false);
            onChange(v);
          }
        }}
      >
        <SelectTrigger data-testid={`${testid}-select`}>
          <SelectValue placeholder="Seleziona un titolo…" />
        </SelectTrigger>
        <SelectContent>
          {presets.map((p) => (
            <SelectItem key={p} value={p}>{p}</SelectItem>
          ))}
          <SelectItem value="__custom__">✏️ Personalizzato…</SelectItem>
        </SelectContent>
      </Select>
      {custom && (
        <Input
          placeholder="Scrivi il titolo del documento"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          data-testid={`${testid}-custom-input`}
        />
      )}
    </div>
  );
}
